import { Injectable } from '@angular/core';
import { Observable, Observer, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { delay } from 'rxjs/operators';
import { dataSourceItems } from '../db/dataSourceItems';
import { dataJobTitle } from '../db/dataJobTitle';
import { dataEmployee } from '../db/dataEmployee';
import { dbCountries } from '../db/dbCountries';
import { dbSignup } from '../db/dbSignup';
import { login } from '../db/login';
import { validateLoggedInSession } from '../db/validateLoggedInSession';
import { forgotPassword } from '../db/forgotPassword';
import { sourceConfiguration } from '../db/sourceConfiguration';
import { Sources } from '../db/Sources';
import { testSource } from '../db/testSource';
import { Targets } from '../db/Targets';
import { dataTargetItems } from '../db/dataTargetItems';
import { TargetConfiguration } from '../db/TargetConfiguration';
import { testTarget } from '../db/testTarget';
import { RecentViewsList } from '../db/RecentViewsList';
import { sourceColoumns } from '../db/sourceColoumns';
import { getBridges } from '../db/getBridges';
import { UpdatesList } from '../db/UpdatesList';

declare const window: any;

@Injectable()
export class BackendService {
    baseConfig: any;
    constructor(public http: HttpClient) {
        this.baseConfig = { ...window.__env };
    }

    private _getMockResponse = key => {
        const mockObj = BackendDataQueue.get(key);
        return of(mockObj.data).pipe(delay(mockObj.delay));
    };

    Get<T>(key, params?, options?, smartSubstitution?): Observable<any> {
        return this._getMockResponse(key);
    }

    Put(key, params?, options?): Observable<any> {
        return this._getMockResponse(key);
    }

    Post(key, params?, options?): Observable<any> {
        return this._getMockResponse(key);
    }
}

const db = {
    register: dbSignup,
    login: login,
    getDataJobTitle: dataJobTitle,
    getDataEmployee: dataEmployee,
    getDataCountries: dbCountries,
    validateLoggedInSession: validateLoggedInSession,
    forgotPassword: forgotPassword,
    getSourceList: Sources,
    getSource: dataSourceItems,
    saveSource: sourceConfiguration,
    testSource: testSource,
    getTargetList: Targets,
    getTarget: dataTargetItems,
    saveTarget: TargetConfiguration,
    testTarget: testTarget,
    getsourceColoumns: sourceColoumns,
    getBridges: getBridges,
    getRecentViewsList: RecentViewsList,
    getUpdatesList: UpdatesList
};


const BackendDataQueue = (function () {
    const defaultDelayInMilliseconds = 1000;
    const defaultValues = db;
    function getFromQueue(key) {
        return { delay: defaultDelayInMilliseconds, data: defaultValues[key] };
    }
    return {
        get: getFromQueue,
    };
})();
